<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_17558_225084"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M18.599 7.82366L17.7903 8.41183V8.41183L18.599 7.82366ZM21.6175 11.974L22.4262 11.3859V11.3859L21.6175 11.974ZM16.5 11C15.9477 11 15.5 11.4477 15.5 12C15.5 12.5523 15.9477 13 16.5 13V11ZM21.5 13C22.0523 13 22.5 12.5523 22.5 12C22.5 11.4477 22.0523 11 21.5 11V13ZM4 5V6H11V5V4H4V5ZM13 7H12V17H13H14V7H13ZM2 15H3V7H2H1V15H2ZM6 17V16H4V17V18H6V17ZM13 17V16H10V17V18H13V17ZM2 15H1C1 16.6569 2.34315 18 4 18V17V16C3.44772 16 3 15.5523 3 15H2ZM11 5V6C11.5523 6 12 6.44772 12 7H13H14C14 5.34315 12.6569 4 11 4V5ZM4 5V4C2.34315 4 1 5.34315 1 7H2H3C3 6.44772 3.44772 6 4 6V5ZM22 13.1504H21V15H22H23V13.1504H22ZM13 7V8H16.9816V7V6H13V7ZM18.599 7.82366L17.7903 8.41183L20.8087 12.5622L21.6175 11.974L22.4262 11.3859L19.4078 7.23548L18.599 7.82366ZM16 17V16H13V17V18H16V17ZM20 17V16H19.5V17V18H20V17ZM16.9816 7V8C17.3015 8 17.6021 8.15308 17.7903 8.41183L18.599 7.82366L19.4078 7.23549C18.8432 6.45925 17.9414 6 16.9816 6V7ZM22 13.1504H23C23 12.5163 22.7991 11.8986 22.4262 11.3859L21.6175 11.974L20.8087 12.5622C20.933 12.7331 21 12.939 21 13.1504H22ZM22 15H21C21 15.5523 20.5523 16 20 16V17V18C21.6569 18 23 16.6569 23 15H22ZM20 17H19C19 17.5523 18.5523 18 18 18V19V20C19.6569 20 21 18.6569 21 17H20ZM18 19V18C17.4477 18 17 17.5523 17 17H16H15C15 18.6569 16.3431 20 18 20V19ZM16 17H17C17 16.4477 17.4477 16 18 16V15V14C16.3431 14 15 15.3431 15 17H16ZM18 15V16C18.5523 16 19 16.4477 19 17H20H21C21 15.3431 19.6569 14 18 14V15ZM10 17H9C9 17.5523 8.55228 18 8 18V19V20C9.65685 20 11 18.6569 11 17H10ZM8 19V18C7.44772 18 7 17.5523 7 17H6H5C5 18.6569 6.34315 20 8 20V19ZM6 17H7C7 16.4477 7.44772 16 8 16V15V14C6.34315 14 5 15.3431 5 17H6ZM8 15V16C8.55228 16 9 16.4477 9 17H10H11C11 15.3431 9.65685 14 8 14V15ZM16.5 12V13H21.5V12V11L16.5 11V12Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0_17558_225084)">
      <rect width="24" height="24" fill="#39444C" />
    </g>
  </svg>
</template>
